type LogoProps = {
  /** Display height in px; width scales with the image aspect ratio. */
  height?: number;
  className?: string;
  title?: string;
  /** Use the white wordmark over dark / cinematic surfaces. */
  variant?: "default" | "white";
};

const LOGO_SRC: Record<NonNullable<LogoProps["variant"]>, string> = {
  default: "/albavox-logo-text.png",
  white: "/albavox-logo-white.png",
};

/**
 * ALBAVOX wordmark for header and footer.
 * Icon-only marks (`albavox-icon*.png`) are used in `index.html` for favicons.
 */
export function Logo({
  height = 36,
  className,
  title = "ALBAVOX",
  variant = "default",
}: LogoProps) {
  return (
    <img
      src={LOGO_SRC[variant]}
      alt={title}
      height={height}
      draggable={false}
      className={className}
      style={{ width: "auto", display: "block" }}
    />
  );
}
